import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

export default (you, others, formatMessage) => {
  if (others.length === 0) {
    return formatMessage({id: "recognition.utils.usersToString.youSingle.title"})
  }
  if (others.length === 1) {
    return formatMessage({id: "recognition.utils.usersToString.youAndOneOther.title"},
      {otherName: firstnameLastname(others[0])})
  }
  if (others.length === 2) {
    return formatMessage({id: "recognition.utils.usersToString.youAndTwoOthers.title"},
      {otherNameOne: firstnameLastname(others[0]), otherNameTwo: firstnameLastname(others[1])})
  }
  return formatMessage({id: "recognition.utils.usersToString.fourOrMore.title"},
    {nbOfUsers: others.length + 1})
}
